import { render, staticRenderFns } from "./CallLogList.vue?vue&type=template&id=39d4844f&scoped=true&"
import script from "./CallLogList.vue?vue&type=script&lang=js&"
export * from "./CallLogList.vue?vue&type=script&lang=js&"
import style0 from "./CallLogList.vue?vue&type=style&index=0&id=39d4844f&prod&lang=scss&scoped=true&"
import style1 from "./CallLogList.vue?vue&type=style&index=1&id=39d4844f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d4844f",
  null
  
)

export default component.exports